<script setup lang="ts">
import { numberWithCommas } from '@/utils/number-with-commas'

const props = defineProps({
  data: Object,
})
</script>

<template>
    <div class="bg-white rounded-xl p-5 h-[138px] flex flex-col justify-between transition-shadow hover:shadow-md">
        <h3 class="text-sm text-[#1b325a] font-medium mb-2">{{ data?.label }}</h3>
        <div class="flex items-center"
            :class="data?.currency === 'COUNT' && data?.linkLabel ? 'justify-between' : 'justify-end'">
            <a v-if="data?.linkTo" :href="data?.linkTo"
                class="text-[10px] text-[#25a658] hover:underline mt-4 font-medium inline-flex items-center gap-1.5">
                {{ data?.linkLabel }}
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 rotate-180" fill="none" viewBox="0 0 22 22"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M9 5l7 7-7 7" />
                </svg>
            </a>
            <p v-if="data?.currency === 'COUNT'"
                class=" px-2 h-[52px] text-[22px] font-fa font-medium min-w-[52px] flex items-center justify-center  text-[#1b325a] bg-[#eaeef5] rounded-md ">
                {{ data?.price ? numberWithCommas(data?.price) : 0 }}
            </p>

            <p v-else
                class=" text-[13px] font-medium px-2 h-9 flex items-center gap-1 text-[#1b325a] bg-[#eaeef5] rounded-md ">
                <span class="font-fa ">
                    {{ data?.price ? numberWithCommas(data?.price) : 0 }}
                </span>
                <span>تومان</span>
            </p>
        </div>
    </div>
</template>
